module.exports = "<div class=\"edit-export-user-catalog\" *ngIf=\"canExportUserCatalog\">\n  <h3 class=\"edit-header\">Export user catalog</h3>\n  <br />\n  <button class=\"sg-btn sg-blue edit-administer-btn\" *ngIf=\"canExportUserCatalog\" (click)=\"exportUserCatalog()\">Download catalog</button>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/management/components/userexport/userexport.component.html
// module id = ./src/app/management/components/userexport/userexport.component.html
// module chunks = main